<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <div class="detailside">
        <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
      </div>
      <!-- <div class="side">
   <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
</div> -->
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main" style="width:70%">
        <div class="brand-card brandcard">
          <div class="col-md-12 designtitle">
            <div class="col-md-12">
              Design Title:<strong>
                &nbsp;{{ style_details.design_title }}</strong
              >
            </div>
            <div class="col-md-12">
              Style Name : &nbsp;{{ style_details.style_name }} >>
              {{ style_details.sub_cattitle }}
            </div>
            <div class="col-md-12">
              Created Date : {{ style_details.created_date }}
            </div>
            <div class="col-md-12">
              Buyer Name : {{ style_details.sendqname }}
            </div>
          </div>
          <navbarMenu></navbarMenu>
          <br />

          <div class="col-md-12" v-if="user_type != 'Quality_Controller'">
            <b-row class="col-md-12 dropdowndesign">
              <b-col
                md="12"
                class="pull-right text-right"
                v-if="style_details.operational_status != 'DH-rejected'"
              >
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="getStyleActivityLog(), getlocationandzonewisevendor()"
                >
                  Inspection Request
                </button>
                <!-- <div class="pull-right"> -->
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <!-- <template v-slot:button-content>
              <button type="button" class="btn btn-default" @click="getStyleActivityLog();"><i class="fa fa-exchange" aria-hidden="true" style="background-color: none; color: #DAA520; width: 20px;"></i>Activity Logs</button> 
              <span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span>
            </template> -->
                  <!-- <b-dropdown-item style="font-size: 20px;"> 
              <button type="button" class="btn btn-default" @click="getStyleActivityLog();"><i class="fa fa-exchange" aria-hidden="true" style="background-color: none; color: #DAA520; width: 20px;"></i>Activity Logs</button> 
            </b-dropdown-item>
             -->
                  <!-- v-if="style_details.operational_status=='DH-Feedback' || style_details.operational_status=='BH-Feedback' || style_details.operational_status=='FH-Feedback' || style_details.is_draft==1" -->

                  <!-- v-if="style_details.operational_status=='DH-Feedback' || style_details.operational_status=='BH-Feedback' || style_details.operational_status=='FH-Feedback' || style_details.is_draft==1" -->
                  <!-- {{style_details.operational_status}} -->
                  <!-- || style_details.is_draft==1 -->
                  <!-- <b-dropdown-item>
              <button v-if="(style_details.operational_status=='DH-Feedback' || style_details.operational_status=='BH-Feedback' || style_details.operational_status=='FH-Feedback' || style_details.is_draft==1) && user_type=='Brand_Designer'" type="button" class="btn btn-link" @click="editStyledesign(style_details);setSelectedcolor(selected_pantone_no,0)"><i class="fa fa-pencil" variant="primary" aria-hidden="true" style="color: #1E90FF; " ></i><label style="color: #585858;">Edit Style</label></button>
          </b-dropdown-item> -->

                  <!-- <b-dropdown-item >
              <button v-if="( style_details.is_draft==1 && user_type=='Brand_Manager')" type="button" class="btn btn-link" @click="editStyledesign(style_details);setSelectedcolor(selected_pantone_no,0)"><i class="fa fa-pencil" variant="primary" aria-hidden="true" style="color: #1E90FF; " ></i><label style="color: #585858;">Edit Style</label></button>
          </b-dropdown-item> -->

                  <b-dropdown-item
                    style="font-size: 20px;"
                    v-if="
                      user_type == 'Brand_Manager' &&
                        style_details.operational_status == 'DH-approved' &&
                        block_status != false
                    "
                  >
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="addcomment"
                    >
                      <i
                        class="fa fa-pencil"
                        aria-hidden="true"
                        style="background-color: none; color: #6495ED; width: 20px;"
                      ></i
                      >Update Status
                    </button>
                  </b-dropdown-item>
                </b-dropdown>
                <!-- </div> -->
              </b-col>
            </b-row>

            <!-- Full screen overlay for side bar -->
          </div>

          <b-row>
            <b-col md="11">
              <b-table
                show-empty
                hover
                stacked="md"
                style="table-layout: fixed"
                :outlined="outlined"
                :items="inspection_data"
                :bordered="bordered"
                :fields="inspection_fields"
                caption-top
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template slot="table-caption"><b>Inspection List</b></template>

                <template slot="offeredquantityslot" slot-scope="row">
                  <p
                    v-if="
                      row.item.offered_quantity == null ||
                        row.item.offered_quantity == ''
                    "
                  >
                    NA
                  </p>
                  <p
                    v-if="
                      row.item.offered_quantity != null ||
                        row.item.offered_quantity != ''
                    "
                  >
                    {{ row.item.offered_quantity }}
                  </p>
                </template>

                <template slot="protoactions" slot-scope="row">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <span class="cui-options icons font-1xl d-block"></span>
                    </template>

                    <b-dropdown-item>
                      <span
                        v-b-modal.Detailsprotomodel
                        @click="editinfoModal(row.item)"
                      >
                        Show Details
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>

                <!--             
              <template slot="vendor_sample_image" slot-scope="row"> 
                  <img v-bind:src="row.item.vendor_sample_image" style="width:100%;height:100%;"/> -->
                <!-- <b-img-lazy :blank-src="null" :src="row.item.vendor_sample_image" alt="Sample Image" style="width:100%;height:100%;"></b-img-lazy> -->
                <!-- </template>
                               
                -->
              </b-table>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- See details of inspection -->
      <b-modal
        title="Update Password"
        v-model="allocate_inspection"
        @ok="allocate_inspection = false"
        size="xl"
      >
        <template slot="modal-header" slot-scope="{ close }">
          <h5>Allocate Inspection</h5>
          <b-form-group style="float:right;">
            <b-button variant="danger" @click="editcancel()"
              ><i class="fa fa-times"></i
            ></b-button>
          </b-form-group>
        </template>

        <template slot="default" slot-scope="{ hide }">
          <div>
            <b-card no-body>
              <b-tabs pills card>
                <b-tab title="Style Detail Information" active>
                  <b-card-text>
                    <!-- INFORMATION TAB STARTS HERE -->
                    <b-form
                      @submit.prevent="validateForm5('form-5')"
                      data-vv-scope="form-5"
                    >
                      <b-row>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Style Name :</b></label>
                            </b-col>

                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.design_title }}
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Style Code :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.style_code }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Style Color :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.color }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Product Description :</b></label
                              >
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.style_description }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Buyer Name :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.sendqname }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Vendor Name :</b></label>
                            </b-col>
                            <!-- -->
                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.vendor_name }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <!-- <b-col md="4">
                              <b-form-group>
                                <b-col md="12" class="pull-left">
                                  <label for="name"><b>Inspection For QC </b> <span style="color:red;">*</span> </label>
                                </b-col> 
                                
                                  <select class="col-md-8 ml-3 form-control" v-model="qc_name" id="qc_name" name="qc_name" required>
                                      <option value="select">--Select--</option>
                                      <option value="ajinkya">Ajikya</option>
                                      <option value="abhijeet">Abhijeet</option>
                                      <option value="shamal">Shamal</option>

                                  </select>
                                
                              </b-form-group>
                            </b-col>
                          -->
                        <!-- <b-col md="6">
                              <b-form-group>
                                <b-col md="4" class="pull-left">
                                  <label for="name"><b>MRP</b></label>
                                </b-col> 
                                <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                                <b-col md="7" class="pull-right titleb"><i class="fa fa-rupee"></i> {{style_details_qc.total_amount}} 
                                </b-col>
                            </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group>
                                <b-col md="4" class="pull-left">
                                  <label for="name"><b>Total Ordered Quantity</b></label>
                                </b-col> 
                                <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                                <b-col md="7" class="pull-right titleb">{{style_details_qc.quantity}}
                                </b-col>
                            </b-form-group>
                            </b-col> -->

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>PO no. :</b></label>
                            </b-col>

                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.po_id }}
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Brand :</b></label>
                            </b-col>

                            <b-col md="12" class="pull-right titleb"
                              >{{ style_details.brand_title }}
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Location :</b></label>
                            </b-col>

                            <b-col
                              v-if="
                                selected_inspection_data.location != null ||
                                  selected_inspection_data.location != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.location }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.location == null ||
                                  selected_inspection_data.location == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row
                        class=""
                        v-if="
                          selected_inspection_data.inspection_status == 'RFT' ||
                            selected_inspection_data.inspection_status ==
                              'Hold' ||
                            selected_inspection_data.inspection_status ==
                              'Pending'
                        "
                      >
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>MRP :</b></label>
                            </b-col>

                            <b-col
                              v-if="
                                selected_inspection_data.mrp != null ||
                                  selected_inspection_data.mrp != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.mrp }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.mrp == null ||
                                  selected_inspection_data.mrp == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Total Quantity :</b></label>
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.total_quantity !=
                                  null ||
                                  selected_inspection_data.total_quantity != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.total_quantity }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.total_quantity ==
                                  null ||
                                  selected_inspection_datatotal_quantity == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Inspected Quantity :</b></label
                              >
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_quantity !=
                                  null ||
                                  selected_inspection_data.inspection_quantity !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{
                                selected_inspection_data.inspection_quantity
                              }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_quantity ==
                                  null ||
                                  selected_inspection_data.inspection_quantity ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                            <!-- <b-col md="12" class="pull-right titleb">{{inspection_quantity}}
                                  </b-col> -->
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Passed Quantity :</b></label>
                            </b-col>

                            <b-col
                              v-if="
                                selected_inspection_data.passed_quantity !=
                                  null ||
                                  selected_inspection_data.passed_quantity != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.passed_quantity }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.passed_quantity ==
                                  null ||
                                  selected_inspection_data.passed_quantity == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{passed_quantity}}
                                  </b-col> -->
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Rc/Reject/Defect Quantity :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{reject_quantity}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.reject_quantity !=
                                  null ||
                                  selected_inspection_data.reject_quantity != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.reject_quantity }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.reject_quantity ==
                                  null ||
                                  selected_inspection_data.reject_quantity == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>No. of Carton Inspected :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{carton_inspected}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.carton_inspected !=
                                  null ||
                                  selected_inspection_data.carton_inspected !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.carton_inspected }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.carton_inspected ==
                                  null ||
                                  selected_inspection_data.carton_inspected ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Inspection Type :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{inspection_type}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_type !=
                                  null ||
                                  selected_inspection_data.inspection_type != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.inspection_type }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_type ==
                                  null ||
                                  selected_inspection_data.inspection_type == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Inspection Process :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{inspection_process}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_process !=
                                  null ||
                                  selected_inspection_data.inspection_process !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.inspection_process }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.inspection_process ==
                                  null ||
                                  selected_inspection_data.inspection_process ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Stitching Quality :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{stiching_quality}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.stiching_quality !=
                                  null ||
                                  selected_inspection_data.stiching_quality !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.stiching_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.stiching_quality ==
                                  null ||
                                  selected_inspection_data.stiching_quality ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Wash Care Label :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{wash_lable}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.wash_lable != null ||
                                  selected_inspection_data.wash_lable != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.wash_lable }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.wash_lable == null ||
                                  selected_inspection_data.wash_lable == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Hang Tag :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{hand_teg}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.hand_teg != null ||
                                  selected_inspection_data.hand_teg != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.hand_teg }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.hand_teg == null ||
                                  selected_inspection_data.hand_teg == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Main Label :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{main_label}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.main_label != null ||
                                  selected_inspection_data.main_label != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.main_label }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.main_label == null ||
                                  selected_inspection_data.main_label == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Size Label :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{size_label}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.size_label != null ||
                                  selected_inspection_data.size_label != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.size_label }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.size_label == null ||
                                  selected_inspection_data.size_label == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Fabric Color :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{fabric_color}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_color != null ||
                                  selected_inspection_data.fabric_color != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.fabric_color }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_color == null ||
                                  selected_inspection_data.fabric_color == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Fabric Quality :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{fabric_quality}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_quality !=
                                  null ||
                                  selected_inspection_data.fabric_quality != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.fabric_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.fabric_quality ==
                                  null ||
                                  selected_inspection_data.fabric_quality == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Print Quality :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{print_quality}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.print_quality !=
                                  null ||
                                  selected_inspection_data.print_quality != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.print_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.print_quality ==
                                  null ||
                                  selected_inspection_data.print_quality == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>Embroidery :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{embroidery}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.embroidery != null ||
                                  selected_inspection_data.embroidery != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.embroidery }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.embroidery == null ||
                                  selected_inspection_data.embroidery == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Button Hole/Attachment :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{button_hole}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.button_hole != null ||
                                  selected_inspection_data.button_hole != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.button_hole }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.button_hole == null ||
                                  selected_inspection_data.button_hole == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Barcode With MRP :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{barcode_mrp}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.barcode_mrp != null ||
                                  selected_inspection_data.barcode_mrp != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.barcode_mrp }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.barcode_mrp == null ||
                                  selected_inspection_data.barcode_mrp == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b>Over Lock Stitch Quality :</b></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{overlook_quality}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.overlook_quality !=
                                  null ||
                                  selected_inspection_data.overlook_quality !=
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.overlook_quality }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.overlook_quality ==
                                  null ||
                                  selected_inspection_data.overlook_quality ==
                                    ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>GPT :</b></label>
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{gpt}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.gpt != null ||
                                  selected_inspection_data.gpt != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.gpt }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.gpt == null ||
                                  selected_inspection_data.gpt == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"><b>AQL :</b></label>
                            </b-col>

                            <b-col md="12">
                              <table class="table table-bordered">
                                <tr>
                                  <th>Major</th>
                                  <th>Minor</th>
                                  <th>Critical</th>
                                </tr>
                                <tr>
                                  <td>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Major ==
                                          null ||
                                          selected_inspection_data.aql.Major ==
                                            ''
                                      "
                                    >
                                      NA
                                    </p>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Major !=
                                          null ||
                                          selected_inspection_data.aql.Major !=
                                            ''
                                      "
                                    >
                                      {{ selected_inspection_data.aql.Major }}
                                    </p>
                                  </td>

                                  <td>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Minor ==
                                          null ||
                                          selected_inspection_data.aql.Minor ==
                                            ''
                                      "
                                    >
                                      NA
                                    </p>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Minor !=
                                          null ||
                                          selected_inspection_data.aql.Minor !=
                                            ''
                                      "
                                    >
                                      {{ selected_inspection_data.aql.Minor }}
                                    </p>
                                  </td>

                                  <td>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Critical ==
                                          null ||
                                          selected_inspection_data.aql
                                            .Critical == ''
                                      "
                                    >
                                      NA
                                    </p>
                                    <p
                                      v-if="
                                        selected_inspection_data.aql.Critical !=
                                          null ||
                                          selected_inspection_data.aql
                                            .Critical != ''
                                      "
                                    >
                                      {{
                                        selected_inspection_data.aql.Critical
                                      }}
                                    </p>
                                  </td>
                                </tr>
                              </table>
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b
                                  >Checked Against Size Chart (Within / Out of )
                                  Tolerance :</b
                                ></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{size_chart}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.size_chart != null ||
                                  selected_inspection_data.size_chart != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.size_chart }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.size_chart == null ||
                                  selected_inspection_data.size_chart == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group>
                            <b-col md="12" class="pull-left">
                              <label for="name"
                                ><b
                                  >Checked Against PP Sample/Comments Sheet :</b
                                ></label
                              >
                            </b-col>

                            <!-- <b-col md="12" class="pull-right titleb">{{check_pp_sample}}
                                  </b-col> -->
                            <b-col
                              v-if="
                                selected_inspection_data.check_pp_sample !=
                                  null ||
                                  selected_inspection_data.check_pp_sample != ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >{{ selected_inspection_data.check_pp_sample }}
                            </b-col>
                            <b-col
                              v-if="
                                selected_inspection_data.check_pp_sample ==
                                  null ||
                                  selected_inspection_data.check_pp_sample == ''
                              "
                              md="12"
                              class="pull-right titleb"
                              >NA
                            </b-col>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col
                          md="4"
                          v-if="
                            selected_inspection_data.inspection_status ==
                              'Requested'
                          "
                        >
                          <b-form-group>
                            <label for="actionforapproveqc">Action</label>
                            <b-input-group class="mb-3">
                              <b-form-select
                                v-model="actionforapproveqc"
                                :options="options2"
                                id="actionforapproveqc"
                                name="actionforapproveqc"
                                required
                              >
                                <!-- <option :value="select" >--Select--</option> -->
                              </b-form-select>
                            </b-input-group>

                            <b-form-input
                              type="text"
                              :value="selected_inspection_data.inspection_id"
                              v-model="inspection_id"
                              hidden
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <div slot="footer" class="text-right mt-12">
                        <b-button
                          type="submit"
                          class="mr-3"
                          variant="primary"
                          v-if="
                            selected_inspection_data.inspection_status ==
                              'Requested'
                          "
                          >Submit</b-button
                        >

                        <a
                          :href="selected_inspection_data.report_file_path"
                          target="_blank"
                          download
                        >
                          <b-button
                            type="button"
                            class="mr-3"
                            variant="success"
                            v-if="
                              selected_inspection_data.inspection_status ==
                                'RFT' ||
                                selected_inspection_data.inspection_status ==
                                  'Hold' ||
                                selected_inspection_data.inspection_status ==
                                  'Pending'
                            "
                            >Download</b-button
                          >
                        </a>
                        <b-button variant="danger" @click="editcancel()"
                          >cancel</b-button
                        >
                      </div>
                    </b-form>
                  </b-card-text>
                </b-tab>

                <!-- ~~~~~INFORAMTION TAB ENDS HERE~~~~~~~ -->

                <!-- ~~~~~~~~~~~~~ COMMENT TAB~~~~~~~~~~~~~~ -->
                <b-tab
                  title="Comments"
                  v-if="
                    selected_inspection_data.inspection_status == 'RFT' ||
                      selected_inspection_data.inspection_status == 'Hold'
                  "
                >
                  <b-card-text>
                    <b-row
                      v-for="comment_item in comment_details"
                      :key="comment_item"
                    >
                      <b-col md="12">
                        <!-- <table class="table table-bordered">
                            <tr>
                              <th>Defect Name</th>
                              <th>Comment</th>
                            </tr>
                            <tr>
                              <td>{{comment_item.defect_type}}</td>
                              <td>{{comment_item.message}}</td>
                            </tr>
                          </table> -->
                        <b-form-group>
                          <b-col md="12" class="pull-left">
                            <!-- <label for="name"><b>{{comment_label}}:</b></label> -->
                          </b-col>
                          <b-col
                            >{{ comment_item.defect_type }} -
                            {{ comment_item.message }}
                          </b-col>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-tab>

                <!-- ~~~~~~~~~~~~~~ Comment sab ends  ~~~~~~~~~~~~~~~~~~~-->

                <!-- ~~~~~~~~~~~~ Image tab starts ~~~~~~~~~~~~~~~~~~~~~ -->

                <b-tab
                  title="Images"
                  v-if="
                    selected_inspection_data.inspection_status == 'RFT' ||
                      selected_inspection_data.inspection_status == 'Hold'
                  "
                >
                  <b-card-text>
                    <div
                      class="accordion"
                      role="tablist"
                      v-for="(image_item, index) in image_details"
                      :key="image_item"
                    >
                      <b-card no-body class="mb-1">
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-button
                            block
                            v-b-toggle="'accordion' + index"
                            variant="light"
                            style="text-align: left;"
                            >{{ image_item.image_type }}</b-button
                          >
                        </b-card-header>
                        <b-collapse
                          :id="'accordion' + index"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body class="mt-3">
                            <img
                              v-for="image in image_item.image_path"
                              :src="image"
                              :key="image"
                              @click="openimage(image)"
                              height="100px"
                              width="100px"
                              style="padding:5px; cursor: pointer;"
                            />
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </b-card-text>
                </b-tab>

                <!-- ~~~~~~~~~~~~~~Image tan ends ~~~~~~~~~~~~~~~~~~~~~~~ -->
              </b-tabs>
            </b-card>
          </div>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>

      <!-- Ends -->

      <!-- Image Zoom Model -->
      <b-modal
        id="modal-lg"
        size="lg"
        title="Image Zoom"
        v-model="openimagemodel"
        @ok="openimagemodel = false"
      >
        <template slot="modal-header">
          <h5>Zoom Image</h5>

          <b-button
            size="sm"
            @click="openimagecancel()"
            style="background: none; border: none;"
            ><i class="fa fa-close"></i
          ></b-button>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <div class="main1 mb-3" style="text-align: center;">
            <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;" /> -->
            <div>
              <img
                v-bind:src="image_model"
                id="map"
                height="220"
                width="270"
                style="padding:5px;"
              />
            </div>

            <div id="btn_navbar">
              <button type="button" class="btn btn-success" @click="zoomin()">
                <i class="fa fa-search-plus" aria-hidden="true"
                  >&nbsp;Zoom In</i
                ></button
              >&nbsp;
              <button type="button" class="btn btn-danger" @click="zoomout()">
                <i class="fa fa-search-minus" aria-hidden="true"
                  >&nbsp;Zoom Out</i
                >
              </button>
            </div>
          </div>

          <div slot="footer" class="text-right">
            <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
            <b-button size="sm" variant="danger" @click="openimagecancel()"
              >cancel</b-button
            >
          </div>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
      <!-- Image Zoom Model -->

      <!-- Code For Schedule Inspection -->
      <b-modal
        title="Inspection Request"
        v-model="qcInspectionModel"
        @ok="qcInspectionModel = false"
        size="lg"
      >
        <h5>Inspection Request</h5>

        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-5')"
            data-vv-scope="form-5"
          >
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Style Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details.design_title }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Style Code</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details.style_code }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Style Color</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details.color }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Product Description</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details.style_description }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Buyer Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details.sendqname }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Vendor Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details.vendor_name }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>MRP</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    ><i class="fa fa-rupee"></i>
                    {{ style_details_qc.total_amount }}
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-col md="4" class="pull-left">
                    <label for="name"><b>Total Ordered Quantity</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                  <b-col md="7" class="pull-right titleb"
                    >{{ style_details_qc.quantity }}
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="5">
                <b-form-group>
                  <label for="location">Location1</label>
                  <b-input-group class="mb-3">
                    <b-form-select
                      v-model="location"
                      :options="locationOptions"
                      id="location"
                      name="location"
                      required
                    >
                    </b-form-select>
                    <!-- <b-form-input class="input" type="text" id="location" v-model="location" name="location" placeholder="Enter Location" required> -->
                    <!-- </b-form-input>   -->
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('location')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-5.location')"
                      id="location"
                      class="help text-danger"
                      >{{ errors.first("form-5.location") }}
                    </code>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md-1></b-col>

              <b-col sm="5">
                <label for="inspectiondate">Inspection Date</label>

                <datepicker
                  :bootstrap-styling="true"
                  placeholder="Select Inspection Date"
                  slot="beforeCalendarHeader"
                  class="calender-header"
                  v-model="inspectiondate"
                  id="enddate"
                  :format="DatePickerFormat"
                  :disabledDates="disabledDates"
                  required
                >
                  Inspection date
                </datepicker>
                <!-- <b-form-input class="input" type="date" id="inspectiondate" v-model="inspectiondate" name="inspectiondate" required>
                        </b-form-input>   -->

                <b-input-group class="mb-3">
                  <span class="icon has-text-warning">
                    <i
                      class="fa fa-warning"
                      v-show="errors.has('inspectiondate')"
                    ></i>
                  </span>
                  <code
                    v-show="errors.has('form-5.inspectiondate')"
                    id="inspectiondate"
                    class="help text-danger"
                    >{{ errors.first("form-5.inspectiondate") }}
                  </code>
                </b-input-group>
              </b-col>
              <b-col md-1></b-col>

              <b-col sm="5">
                <b-form-group>
                  <label for="inspectiontype">Inspection Type</label>
                  <b-input-group class="mb-3">
                    <b-form-select
                      v-model="inspectiontype"
                      :options="options"
                      id="inspectiontype"
                      name="inspectiontype"
                      required
                    >
                      <!-- <option :value="select" >--Select--</option> -->
                    </b-form-select>
                    <!-- <b-form-select id="inspectiontype" name="inspectiontype" required>
                         <option :value="select" >--Select--</option>
                         <option :value="Final" >Final</option>
                         <option :value="Inline" >Inline</option>
                         <option :value="Midline" >Midline</option>
                         <option :value="Size-set" >Size set</option>
                      </b-form-select> -->
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('inspectiontype')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-5.inspectiontype')"
                      id="inspectiontype"
                      class="help text-danger"
                      >{{ errors.first("form-5.inspectiontype") }}
                    </code>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md-1></b-col>
              <b-col sm="5">
                <b-form-group>
                  <label for="inspectionzone">Zone</label>
                  <b-input-group class="mb-3">
                    <b-form-select
                      v-model="inspectionzone"
                      :options="zoneOptions"
                      id="inspectionzone"
                      name="inspectionzone"
                      required
                    >
                      <!-- <option :value="select" >--Select--</option> -->
                    </b-form-select>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('inspectionzone')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-5.inspectionzone')"
                      id="inspectionzone"
                      class="help text-danger"
                      >{{ errors.first("form-5.inspectionzone") }}
                    </code>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md-1></b-col>

              <!-- <b-col sm="4">
                <b-form-group>
                  <label for="actionforapprove">Action</label>
                  <b-input-group class="mb-3">
                    <b-form-select
                      v-model="actionforapprove"
                      :options="options2"
                      id="actionforapprove"
                      name="actionforapprove"
                      required
                    >
                     
                    </b-form-select>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <span class="icon has-text-warning">
                      <i
                        class="fa fa-warning"
                        v-show="errors.has('actionforapprove')"
                      ></i>
                    </span>
                    <code
                      v-show="errors.has('form-5.actionforapprove')"
                      id="actionforapprove"
                      class="help text-danger"
                      >{{ errors.first("form-5.actionforapprove") }}
                    </code>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
            </b-row>
            <div slot="footer" class="text-right">
              <b-button type="submit" variant="success">Submit</b-button> &nbsp;
              <b-button variant="danger" @click="qcInspectioncancle()"
                >cancel</b-button
              >
            </div>
          </b-form>
        </template>
      </b-modal>
      <!-- Code For Schedule Inspection Ends -->
    </b-row>
  </div>
</template>

<script>

   import CONSTANTS from '@/utils/constants'
   import auth from '@/utils/auth'
   import Vue from 'vue'
   import Router from 'vue-router'
   //import {ImageMagnifier} from 'vue-image-magnifier'
   import ImageMagnifier from 'vue-image-magnifier'
   Vue.use(ImageMagnifier)
   import sidebarAllDesignsComponent from './_sidebarAllDesignsComponent.vue'
  import navbarMenu from './_navbarMenu.vue'
import Datepicker from 'vuejs-datepicker'
import { get } from 'core-js/core/dict'

   const axios = require('axios')
   export default {
     name: 'Tabs',
     components: {
        sidebarAllDesignsComponent,
       navbarMenu,
       Datepicker
      },

     computed: {
       locationOptions() {
         // If vendordata exists and has data, use it for location options
         if (this.vendordata && this.vendordata.length > 0) {
           return this.vendordata.map(vendor => ({
             value: vendor.location || vendor.name,
             text: vendor.location || vendor.name
           }));
         }
         // Otherwise, use default options3
         return this.options3;
       },
       zoneOptions() {
         // If vendordata exists and has data, use it for zone options
         if (this.vendordata && this.vendordata.length > 0) {
           return this.vendordata.map(vendor => ({
             value: vendor.zone || vendor.region,
             text: vendor.zone || vendor.region
           }));
         }
         // Otherwise, use default options1
         return this.options1;
       }
     },

     data () {
       return {
         addfile:false,
         showSideMenu:true,
         tabs: [
           'Calculator',
           'Shopping cart',
           'Charts'
         ],

         DatePickerFormat: 'dd/MM/yyyy',
        disabledDates: {
          to: new Date(Date.now() - 8640000)
          },

         quotationAddModal: false,
         allocate_inspection: false,
         msgRows: 0,
         style_details: [],
      style_details_qc:[],
        quateitemlist:[],
        design_title:'',
        story_name: '',
        design_id:'',
        design_date:'',
        collection_title:'',
        imgpath:'',
        totalRows: 0,
        quote_date :'',
        quote_quantity :'',
        quote_currency :'',
        quote_prce_per :'',
        price_per_garment : '',
        quote_status :'',
        quote_unit : '',
        quantity :[],
        visible : true,
          list: [],
          customer: {},
          messagedata: [],
          selectedId: 0,
          txtInput: '',
       title:'',
       design_no:'',
       uploadfilemodel:false,
       activitylogsmodel: false,
        quote_tab:false,
        message_tab: false,
        files_list:[],
        nav_design_list :[],
        catselected: '',
        subcatselected:'',
        cat_title: '',
        sub_cat_title:'',

        file_title:'',
        file_category:'',
        file_url_path:'',
        file_Category_options: [

          { value: 'Technical Pack', text: 'Technical Pack' },
          { value: 'Fabric', text: 'Fabric' },
          { value: 'Constructions', text: 'Constructions' },

        ],
        options: [
          { value: 'Final', text: 'Final' },
          { value: 'Inline', text: 'Inline' },
          { value: 'Midline', text: 'Midline' },
          { value: 'Size_set', text: 'Size set' },

        ],

        no_of_unit:[
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' }
        ],
        color_family:[],

        //Code for sampling
        requestSampleModal: false,
        // requestedlisting:[],

        selectedDate: new Date(),
        // items:[],
        result:[],
        sample_data: [],
        //Sampling code ends

        colortype: {},
        customer: {},
        colorcode:{},
        color_name:[],
        color_family:[],
        pantoncolor: [],
        showhexcolor:'',
        pantonno_result:[],
        showcolorname:'',
        SelectPantonType: '',

        comment_details: [],
        image_details:[],

      quoteunit: [
        { value: 'INR', text: 'INR' }

      ],

         activeTab: 1,
         image_model:'',

         //New Added Code
         editdesign: false,
         design_categoty_id: 0,
         design_subcategoty_id: 0,
         updated_by:'',
         segment_id: 0,
         utility_type_arr: [],
         no_of_units_in_pack: 0,
         no_of_colors: 0,
         no_of_size_sets: 0,
         style_image:'',
         file:'',
         po_typearr: [],
         sub_cat: [],
         selectedPO_type: null,
         selected_sub_category: null,
         selected:'',
         route_id: '',
         addcommentModel: false,
         qcInspectionModel:  false,
         comment: '',
         status: '',
         user_type: '',
         temp_color: '',
         temp_style_name: '',
         temp_style_image: '',
         temp_style_description:'',
         flag: 0,
         img_data: '',
         temp_sizeset : 0,
         temp_story_name: '',
         temp_style_id:'',
         tp_status: false,
         measurementchart_status: false,
         bom_status: false,
         fileupload_status: false,
         openimagemodel: false,
         opentablemodel: false,
         inspection_id:'',
         //name:"design_details",
         name:"auth",
         component_name: 'design_details',
         uploadedfile: '',
         sampleFile:'',
         sampleImageurl:'',
         chnaged_image: false,
         selected_draft_value: 0,
         remoteUrl: '',
         temp_file: '',
         inspectiondate:'',
         progress:0,
         no_of_sizeset:[
          { value: '0', text: '0' },
          { value: '1', text: '1' },
          { value: '2', text: '2' },
          { value: '3', text: '3' },
          { value: '4', text: '4' },
          { value: '5', text: '5' },
          { value: '6', text: '6' },
          { value: '7', text: '7' },
          { value: '8', text: '8' },
          { value: '9', text: '9' },
          { value: '10', text: '10' },
          { value: '11', text: '11' },
          { value: '12', text: '12' },
          { value: '13', text: '13' },
          { value: '14', text: '14' },
          { value: '15', text: '15' },
          { value: '16', text: '16' },
          { value: '17', text: '17' },
          { value: '18', text: '18' },
          { value: '19', text: '19' },
          { value: '20', text: '20' }
        ],
// ,tdClass: 'nameOfTheClass' tdClass: 'viewClass'
        // fields1: [
        //     { key: 'operation_name', label: 'Operation Name' },
        //     // { key: 'status', label: 'Status'},
        //     { key: 'time', label: 'Time'},
        //     { key: 'time_stamp', label: 'Time Stamp'},
        //     { key: 'initiated_by', label: 'Event Initiated By'},
        //     { key: 'view_details', label: 'View Details'}


      //  ],
       vendors_fields: [
            //{ key: 'selected', label: 'Selected'},tdClass: 'nameOfTheClass'sortable: true, sortDirection: 'desc'
          { key: 'vendor_name', label: 'Vendor Name' },
          { key: 'quantity', label: 'Quantity'},
           { key: 'target_price', label: 'Target Price'},
            { key: 'updated_date', label: 'Request Date' },
            { key: 'effective_date', label: 'Submitted Date'},
            { key: 'status', label: 'Status'},

       ],
       style_activity:[],
       bordered: true,
       activitydetailsModel: false,
       selected_old_value: '',
       selected_new_value: '',
       selected_style_action: '',
       selected_status_code_number: 0,
       vendors_items: [],
       quotation_count: 0,
       quotationlistModel: false,
       isBusy: false,
       perPage:  10,
        currentPage: 1,
        sizeset: [],
        invoice_products:[{
              unit: [],
              selectedfromage: [],
              selectedtoage: [],
              quantity: [],
              factorysize: [],
            }
          ],
      range_selectedfromage: [],
      temp_range_selectedfromage: [],
      range_selectedtoage: [],
      range_selected_month: [],
        selected_month: [],
        selected_age: 0,
        selectedfromage:[],
        selectedtoage: [],
        month_arr: [
              { value: '0', text: '0' },
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],
          year_arr: [
              { value: '0', text: '0' },
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' }
              ],
          to_month_arr: [
              { value: '0', text: '0' },
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' },
              { value: '17', text: '17' },
              { value: '18', text: '18' },
              { value: '19', text: '19' },
              { value: '20', text: '20' },
              { value: '21', text: '21' },
              { value: '22', text: '22' },
              { value: '23', text: '23' },
              { value: '24', text: '24' }
            ],
          to_year_arr: [
              { value: '0', text: '0' },
              { value: '1', text: '1' },
              { value: '2', text: '2' },
              { value: '3', text: '3' },
              { value: '4', text: '4' },
              { value: '5', text: '5' },
              { value: '6', text: '6' },
              { value: '7', text: '7' },
              { value: '8', text: '8' },
              { value: '9', text: '9' },
              { value: '10', text: '10' },
              { value: '11', text: '11' },
              { value: '12', text: '12' },
              { value: '13', text: '13' },
              { value: '14', text: '14' },
              { value: '15', text: '15' },
              { value: '16', text: '16' }
              ],
          agefrmto_default: [
          { value: '', text: '-- Select --' }

          ],
          factorysize: [],
          unit_arr: [
          { value: '0', text: 'Month' },
          { value: '1', text: 'Year' }
          ],
          index:1,
          age_from: [],
          //age_to: [],
          age_to: [],
          total_quantity: 0,
          sizesetselect: false,
          tbl_selected_month:[],
          tbl_selectedfromage:[],
          tbl_selectedtoage:[],
          tbl_invoice_products:[{
            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity: [],
          }
            ],

            tbl_unit: [],
            tbl_selectedfromage: [],
            tbl_selectedtoage: [],
            tbl_factorysize: [],
            tbl_quantity:[],
            selected_color_family: '',
          temp_selected_color_family: '',
          selected_pantone_no: '',
          selected_panton_type: '',
          temp_selected_panton_type: '',
          temp_selected_pantone_no: '',
          otherColor:'',
          selected_color: '',
          selected_final_color: '',
          selected:'',
          block_status: true,
          access_token: '',
          submit_enable_btn: 0,
          temp_index: [],
          temp_unit: [],
          temp_from_age: [],
          temp_to_age: [],
          selected_sizeset: null,
          po_typearr:[],
          selected_po_id:'',
          sub_catid:'',
          user_name: '',
          inspectiontype: '',
          inspectionzone: '',
        //  actionforapprove: '',
          actionforapproveqc:'',
         location: '',

         inspection_data: [],
         selected_inspection_data: {},

        inspection_fields: [{ key: 'location', label: 'Location' },
          { key: 'created_by', label: 'Created By' },
          { key: 'offeredquantityslot', label: 'Offered Quantity' },
          { key: 'inspection_type', label: 'Inspection Type' },
          { key: 'zone', label: 'Zone' },
          { key: 'inspection_status', label: 'Status' },
          { key: 'protoactions', label: 'Action' }

          ],


        options1: [
          { value: 'East', text: 'East' },
          { value: 'West', text: 'West' },
          { value: 'North', text: 'North' },
          { value: 'South', text: 'South' },

         ],

         options2: [
          { value: 'Approved', text: 'Approved' },
          { value: 'Reject', text: 'Reject' },

         ],

         options3: [
           { value: 'Delhi', text: 'Delhi' },
           { value: 'Ludhiana', text: 'Ludhiana' },
           { value: 'Mumbai', text: 'Mumbai' },
           { value: 'Jaipur', text: 'Jaipur' },
           { value: 'Kolkata', text: 'Kolkata' },
           { value: 'New delhi', text: 'New delhi' },
           { value: 'Tirupur', text: 'Tirupur' },
           { value: 'Bangalore', text: 'Bangalore' },
           { value: 'Lahuri', text: 'Lahuri' },


         ],
         vendordata: [],

         //file_tab_status: false,
         //New Added Code Ends
       }
     },
  created: function () {
      var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)

      this.route_id=this.$route.params.id;

      // var userData = localStorage.getItem('userData');
      // var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
      this.user_name = userInfo[0].full_name;
      // console.log("usertype",this.user_type);
    this.getdesigndetail();
    this.getinspectionlisting();
    // this.getcolorfamilylist();



  },

  mounted() {
      },
       methods: {
        setsizeset: function(unit,from_age,to_age){


        this.invoice_products[0].unit=[];
        this.invoice_products[0].selectedfromage=[];
        this.invoice_products[0].selectedtoage=[]
        this.invoice_products=[{
        unit: [],
        selectedfromage: [],
        selectedtoage: [],
        quantity: [],
        factorysize: [],
      }
         ];

        this.range_selected_month= '';
        this.range_selectedtoage=0;
        this.range_selectedfromage=0;

        this.range_selectedtoage=to_age;
        this.range_selectedfromage=from_age;
        this.range_selected_month= unit;

        if(parseInt(from_age)<parseInt(to_age)){
          this.selected_sizeset = this.range_selectedtoage - this.range_selectedfromage;

        this.temp_range_selectedfromage=this.range_selectedfromage;
        for(var i=0;i<=this.selected_sizeset; i++){

            this.invoice_products[0].unit.push(unit);
            this.invoice_products[0].selectedfromage.push(this.temp_range_selectedfromage);
            this.invoice_products[0].selectedtoage.push(parseInt(this.temp_range_selectedfromage)+1);
            this.temp_range_selectedfromage=parseInt(this.temp_range_selectedfromage) +1;
          }

            for(var i=0;i<=this.selected_sizeset;i++){
              this.selected_month[i]=this.invoice_products[0].unit[i];
              this.selectedfromage[i]=this.invoice_products[0].selectedfromage[i];
              this.selectedtoage[i]=this.invoice_products[0].selectedtoage[i];
              this.temp_index.push(i);
            }


          this.sizeset=[];

            for(var i=1;i<=this.selected_sizeset;i++){
          this.sizeset.push(i);
          }

      document.getElementById("sizesetData").style.display="block";
      //     this.temp_unit.push(this.invoice_products[0].unit);
      //     this.temp_from_age.push(this.invoice_products[0].selectedfromage);
      //     this.temp_to_age.push(this.invoice_products[0].selectedtoage);
      // this.temp_index.push(this.temp_index);
      // this.submit_enable_btn=1;
         // this.AddDesignfunction();
          // updatestyle(event,value,unit,from_age,to_age,index);
        }
        else if(parseInt(from_age)>=parseInt(to_age)){

        this.$fire({
                text:"Age To Value Should Be Greater Than Age From Value.",
                type: "warning",
                timer: 30000
                })
      }

     },



         getinspectionimages: function ()
      {
        const Obj = {
          inspection_id: this.inspection_id
        }

        axios.post(`${CONSTANTS.API_URL}/getinspectionimages `, Obj)
          .then(response => {
            document.getElementById("overlay").style.display = "none";

            if (response.data.returnmsg === 'Successful') {

              this.image_details = response.data.returnvalue;
              console.log(this.image_details,"this.this.image_details")

            }

            else {
              this.image_details = [];

              }

          })

          .catch(e => {
          this.errors.push(e)
        })


      },


      getinspectioncomment: function ()
      {
        // alert(this.inspection_id );
        const Obj = {
          inspection_id: this.inspection_id
        }

        axios.post(`${CONSTANTS.API_URL}/getinspectioncomment`, Obj)
          .then(response => {
            document.getElementById("overlay").style.display = "none";

            if (response.data.returnmsg === 'Successful') {

              this.comment_details = response.data.returnvalue;
              // console.log(this.comment_details[0].message,"this.comment_details")

            }

            else {
              this.comment_details = [];
              }

          })

          .catch(e => {
          this.errors.push(e)
        })


      },


      openimage: function (img_path)
      {
        // alert(img_path);
        this.image_model = img_path;
        this.openimagemodel = true;
    },

    getinspectionlisting: function ()
    {

    var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)
      var buyer_id = userInfo[0].user_id;
      var user_type = userInfo[0].user_type;
      // console.log(buyer_id);
      // console.log(style_id);

      const Obj = {

        user_type: user_type,
        buyer_id: userInfo[0].user_id,
        style_id:this.$route.params.id,

      }


        axios.post(`${CONSTANTS.API_URL}/getinspectionlisting`,Obj)
      .then(response => {
        // console.log("**********************", response);
        // console.log(response.data.returnvalue)
        if(response.data.returnmsg==='Successful')
        {
          // console.log(response.data.returnvalue)
          this.inspection_data = response.data.returnvalue;
          console.log(this.inspection_data);

          this.totalRows = this.inspection_data.length;
          // console.log("#################",this.totalRows);


        }
        else{

          this.inspection_data =[];
          this.isBusy = false;
          this.totalRows=0;
          this.isBusy = !this.isBusy;
        }


      }).catch((err) =>{
        this.errors.push(e)
        })


    },


    opensizesetdata: function(value){

      // document.getElementById("size_range").style.display="block";
      this.sizeset=[];
      for(var i=1;i<=value;i++){
        this.sizeset.push(i);
      }

      document.getElementById("sizesetData").style.display="block";
      // this.AddDesignfunction();
    },
                // Change Drop Down Value for Month & Year By Prasad
      range_changeMonthYearVal: function(value_for)
      {

        if(value_for==0) //month
        {
        this.age_from = this.year_arr;
          this.selectedfromage= this.year_arr;
        }
        else
        {
            this.age_from = this.month_arr;
          this.selectedfromage= this.year_arr;
        }

      },

     finalcoloroutput: function(value){
      // alert("Innnnnn")
      if(value==1){
      document.getElementById('final_color_output').style.display="block";
    }
    else{

      document.getElementById('final_color_output').style.display="none";
    }
    },
    colortypecheck: function(value){
      // this.selected_pantone_no='';
      // this.setSelectedcolor(value);
      this.colorcheck=value;
      if(value!='OTHERS' && value!=''){
        document.getElementById('other_value_block').style.display="none";
        document.getElementById('pantom_color_block').style.display="block";
        document.getElementById('default_value_block').style.display="none";
         // document.getElementById('pantom_color_block').style.display="block";
      }
      else{
       // this.selected_pantone_no='';
       // this.setSelectedcolor(value);

        if(value=='OTHERS'){
          document.getElementById('other_value_block').style.display="block";
          document.getElementById('default_value_block').style.display="none";
         document.getElementById('pantom_color_block').style.display="none";
        }

      }
    },

      opensizesetdata: function(value){
        // alert(value)
        this.sizeset=[];
        for(var i=1;i<=value;i++){
          // alert("In")
          this.sizeset.push(i);
        }

      },


         editinfoModal: function (value) {

           this.selected_inspection_data = value,
          this.inspection_id = value.inspection_id,

          this.allocate_inspection = !this.allocate_inspection,

             this.getdesigndetail();
             this.getinspectioncomment();
            this.getinspectionimages();

        // this.getinspectionlisting();
      },



        // Change Drop Down Value for Month & Year By Prasad
      changeMonthYearVal: function(value_for,index)
      {

        if(value_for==0) //month
        {
        //this.age_from[index] ="";
        this.age_from[index] = this.year_arr;
          this.selectedfromage[index]= this.year_arr;
        }
        else
        {
           this.age_from[index] = this.month_arr;
          this.selectedfromage[index]= this.year_arr;
        }

      },

      showactivitydetails(value){
        this.selected_old_value= value.old_value;
        this.selected_new_value= value.new_value;
        this.selected_style_action= value.style_action;
        // console.log("IIIIIIIIIIIIIIIII",value);
        this.activitydetailsModel = !this.activitydetailsModel;
      },

    quotationlistModelcancel: function(){
      this.quotationlistModel= false;
    },

      getStyleActivityLog(){
      const Obj={
            style_id:this.$route.params.id

      }
      axios.post(`${CONSTANTS.API_URL}/getStyleActivityLog`,Obj)
       .then(response => {
        // console.log("**********************",response);
        if(response.data.returnmsg=='Successful')
        {
          this.style_activity = response.data.returnvalue;
          this.qcInspectionModel = true;

        }
        else{
          this.style_activity= response.data.returnvalue;
          this.qcInspectionModel = true;

        }
         this.getquotedeatilsforqc();

      }).catch((err) =>{
          return new Error(err.message);
        })

    },

    getlocationandzonewisevendor(){
      // alert( this.style_details.vendor_code)
      const Obj ={
        vendor_code: this.style_details.vendor_code,
        //  'vowninwpb319f2b',

        // this.style_details.vendor_code,
      }

      axios.post(`${CONSTANTS.API_URL}/getlocationandzonewisevendor`,Obj)
       .then(response => {
        // console.log("**********************",response);
        if(response.data.returnmsg=='Successful')
        {
          this.vendordata = response.data.returnvalue;

        }
        else{
          this.$fire({
                text:"No vendor found for this vendor, showing default values for the location and zone",
                type: "warning",
                timer: 5000
                })
          this.vendordata= response.data.returnvalue;

        }
      }).catch((err) =>{
          return new Error(err.message);
        })
    },
   
      editcancel: function() {
      this.customer = {};
      this.allocate_inspection = !this.allocate_inspection;
        },


         getquotedeatilsforqc() {
          //  alert("QC");
            document.getElementById("overlay").style.display = "block";
            var userData = localStorage.getItem('userData');
            // if (userData)
            // {
                var userInfo = JSON.parse(userData)
                this.vendor_id = userInfo[0].vendor_id;


                const Obj = {
                      style_id:this.$route.params.id

                }

                axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
                .then(response => {
                  document.getElementById("overlay").style.display = "none";
                  // JSON responses are automatically parsed.
                  this.result = response.data
                  if (this.result.returnmsg === 'Successful') {
                    this.style_details_qc  = this.result.returnvalue[0];

                  }else {
                   this.style_details_qc =[];

                      this.isBusy = !this.isBusy;
                  }


                })
                .catch(e => {
                  this.errors.push(e)
                })



         },


    //Panton Color
    getcolorfamilylist: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      const Obj ={"color_type":"TCX"}
      axios.post(`${CONSTANTS.API_URL}/getcolorfamilylist`,Obj)
        .then((result) => {
          if (result.data.returnmsg === 'Successful') {
            this.color_family  = result.data.returnvalue;
          }else {
           this.color_family =[];
          }
        })
        .catch((ex) => {
          // console.log('error', ex)
        })

    },


    vendorsquotesdetails(){
      document.getElementById("overlay").style.display = "block";
       var userData = localStorage.getItem('userData');
      // if (userData)
      // {
           var userInfo = JSON.parse(userData)
           this.vendor_id = userInfo[0].vendor_id;


           const Obj = {
                style_id:this.$route.params.id
              }
           axios.post(`${CONSTANTS.API_URL}/getqutationdetails`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             // JSON responses are automatically parsed.
             this.result = response.data
             this.quotationlistModel= true;
             if (this.result.returnmsg === 'Successful') {
               this.vendors_items = this.result.returnvalue;
               this.isBusy = false;
               // this.totalRows = this.result.returnvalue.length;
               this.quotation_count = this.result.returnvalue.length;
               // for(var i=0;i<=this.quotation_count;i++)
               // {
               //    if(this.items[i].status=='Approved'){
               //      this.selected_status = 'Approved'
               //    }
               // }



             }else {
              this.vendors_items =[];
              this.isBusy = false;
              this.quotation_count=0;
              this.isBusy = !this.isBusy;
             }


           })
           .catch(e => {
             this.errors.push(e)
           })

    },


        zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 2500) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        }
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },

    openimagecancel: function(){
      this.openimagemodel = !this.openimagemodel;
     },
       openNav:function(){
      var opennav=document.getElementById("myNav").style.width = "25%";
     },
     closeNav:function(){
      var closenav=document.getElementById("myNav").style.width = "0%";
     },

    validateForm4(scope) {
      // alert(scope);
      this.$validator.validateAll(scope).then(result => {
        if (result) {

          this.addqcdeatils();

        }
      });
    },

    /************** QC INSPECTION FORM DATA****************** */
    addqcdeatils ()
    {
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      this.buyer_emailid = userInfo[0].email_id;
      this.user_id = userInfo[0].user_id;
      var user_type = userInfo[0].user_type.toLowerCase();



      const Obj = {

             style_id: this.temp_style_id,
             buyer_id: [this.user_id],
             vendor_id:[],
             created_byuser : this.buyer_emailid,
             location: this.location,
             inspection_type: this.inspectiontype,
             inspection_date: this.inspectiondate,
             inspection_zone: this.inspectionzone,
             inspection_status: "Approved",
             created_by: "buyer",

           }

           axios.post(`${CONSTANTS.API_URL}/sendrequestforinspection`,Obj)
                  .then(response => {
                    this.result = response.data
                    console.log(this.result.returnmsg )

                    if (this.result.returnmsg === 'success') {
                      this.$fire({
                          text: "Inspection Requested successfully",
                          type: "success",
                          timer: 30000
                      })

                      // alert("woong")

                      this.qcInspectionModel = !this.qcInspectionModel;
                      // this.sampllingdetails();
                      this.getinspectionlisting();
                    }
                    else
                    {
                      this.$fire({
                          text: this.result.returnvalue,
                          type: "error",
                          timer: 30000
                        })
                    }


                  })
                  .catch(e => {
                    this.errors.push(e)
                  })
                  this.getinspectionlisting();

    },


    validateForm5(scope) {
      // alert(scope);
      this.$validator.validateAll(scope).then(result => {
        if (result) {

          this.approveqcdeatils();

        }
      });
    },

     approveqcdeatils ()
     {

    //  console.log(this.actionforapproveqc)
    var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData)
      var buyer_id = userInfo[0].user_id;

       const Obj =
       {
         buyer_id: userInfo[0].user_id,
         style_id: this.$route.params.id,
         inspection_id : this.inspection_id,
         action: this.actionforapproveqc,

       }

       axios.post(`${CONSTANTS.API_URL}/buyerapproveinspectionreq`, Obj)
         .then(response => {
           document.getElementById("overlay").style.display = "none";
           // JSON responses are automatically parsed.
           this.result = response.data
           this.quotationlistModel = true;
           if (this.result.returnmsg === 'Successful') {

             this.$fire({
               text: "Approved Inspection",
               type: "success",
               timer: 30000
             })
             this.allocate_inspection = !this.allocate_inspection;
             this.getinspectionlisting();

           }

           else {
             this.errors.push(e)


           }


         })

           .catch(e => {
             this.errors.push(e)
           })




    },


    /****** Function to add design image ********/
      AddDesignimage(event){
         this.uploadedfile = event.target.files[0];
         this.chnaged_image= true;
      },
      /****** Function to add design image ends ********/
      editStyledesign:function(style){
        // console.log("style",style);
        this.sub_catid=style.sub_catid;
        this.selected_po_id=style.po_id;
        this.otherColor=style.color;
        this.sampleImageurl=style.sample_image;
       this.editdesign=true;
       this.getPoTypeList();
      },

    //Update Collection Code

     updatestyle(event,value){

      // document.getElementById("overlay").style.display = "block";

      this.invoice_products=[{
            unit: [],
            selectedfromage: [],
            selectedtoage: [],
            quantity: [],
            factorysize: [],
          }
            ];



      this.selected_draft_value= value;
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);

        var check_val=0;

        var main_arr=[];
        main_arr.push(this.invoice_products[0])

       if(this.temp_color!=this.style_details.color || this.temp_style_name!=this.style_details.style_name || this.temp_story_name!=this.style_details.story_name){
          this.flag = 1;

        }

        else if(this.temp_color==this.style_details.color ||this.temp_style_description!=this.style_details.style_description || this.temp_style_name==this.style_details.style_name || this.temp_style_image!= this.style_details.style_image || temp_story_name==this.style_details.story_name){
          this.flag = 0;
        }

        let data = new FormData();
        let config = {
            header : {
             'Content-Type' : 'multipart/form-data'
           }
          }


        if(this.temp_file!= undefined){
          // alert("Iff");
          data.append('file', this.temp_file)
          data.append('sample_image', this.sampleImageurl)
          // console.log("sample_image",this.sampleImageurl)
          data.append('style_id',this.$route.params.id)
          data.append('style_name', this.style_details.style_name)
          data.append('updated_by', userInfo[0].email_id)
          if(this.temp_selected_panton_type=='OTHERS'){
            data.append('color', this.otherColor)
            // console.log(" If color",this.otherColor);
            this.temp_selected_pantone_no='';
            this.selected_final_color='';
          }
          else
          {
            data.append('color', this.selected_final_color);
            //  console.log(" else color",this.selected_final_color);
          }
          data.append('no_of_sizeset', 0)
          data.append('story_name',this.style_details.story_name)
          //  console.log("story_name",this.style_details.story_name)
          data.append('style_description', this.style_details.style_description)
          data.append('brand_id', this.style_details.brand_id)
          data.append('flag', this.flag)
          data.append('is_draft', this.selected_draft_value)
          data.append('size_details',JSON.stringify(main_arr))
          data.append('brand_manager', userInfo[0].brand_manager)
          data.append('pantone_no',this.temp_selected_pantone_no)
          data.append('panton_type',this.temp_selected_panton_type)
          data.append('po_id',this.selected_po_id)
          // console.log("po_type_if",this.selected_po_id)
          // return false;

        }
        else{
          // alert("else");
          //let file = event.target.files[0];
          data.append('file', '')
          data.append('sample_image', this.sampleImageurl)
          data.append('style_id',this.$route.params.id)
          data.append('style_name', this.style_details.style_name)
          data.append('updated_by', userInfo[0].email_id)
          if(this.temp_selected_panton_type=='OTHERS'){
            data.append('color', this.otherColor)
            // console.log(" If color",this.otherColor);
            this.temp_selected_pantone_no='';
            this.selected_final_color='';
          }
          else
          {
            data.append('color', this.temp_selected_pantone_no)
          }
          data.append('no_of_sizeset', 0)
          data.append('story_name',this.style_details.story_name)
          // console.log("story_name",this.style_details.story_name)
          data.append('style_description', this.style_details.style_description)
          data.append('brand_id', this.style_details.brand_id)
          data.append('flag', this.flag)
          data.append('size_details',JSON.stringify(main_arr))
          data.append('is_draft', this.selected_draft_value)
          data.append('pantone_no',this.temp_selected_pantone_no)
          data.append('panton_type',this.temp_selected_panton_type)
          data.append('po_type',this.selected_po_id)
          // console.log("po_type_else",this.selected_po_id)
          // return false;
        }
        // console.log("Data",data);
        // console.log("config",config);
        // return false
        axios.post(`${CONSTANTS.API_URL}/updatestyle`,data, config)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {
            this.sizeset=[];
            this.$fire({
                text:"Updated Successfully.",
                type: "success",
                timer: 30000
                      })
            this.editdesign = false;
            this.customer = {};
            this.invoice_products=[{
              unit: [],
              selectedfromage: [],
              selectedtoage: [],
            }
              ];
            this.getdesigndetail();

          }else {
            this.$fire({
                text:this.result.returnvalue,
                type: "error",
                timer: 30000
                      })
          }


        })

        .catch(e => {
          this.errors.push(e)
        })

    //}



    },
    //Update Collection Code Ends


    editdesigncancel: function() {
      this.customer = {};
      this.editdesign = false;
    },

    qcInspectioncancle: function() {
      this.customer = {};
      this.qcInspectionModel = !this.qcInspectionModel;
    },
    activitydetailscancel: function(){
    this.activitydetailsModel = !this.activitydetailsModel;
    },
    commentcancel: function(){
      this.customer = {};
      this.addcommentModel = !this.addcommentModel;
    },

        //Code Added by Sachin
        //Code for Edit Design
    changedesign: function(value) {
      this.editdesign = !this.editdesign;
    },

     activitylog: function(value) {
      this.qcInspectionModel = !this.qcInspectionModel;
    },
        //Code End For Edit Design
    addcomment: function(value) {
      this.comment='';
      this.status='';
      this.addcommentModel = !this.addcommentModel;
    },


    upload(event){
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      data.append('file', this.uploadedfile)
      data.append('style_id',this.$route.params.id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }

      if(this.uploadedfile.type=='image/jpeg' || this.uploadedfile.type=='image/png'){

      axios.post(`${CONSTANTS.API_URL}/uploaddesignimage`,data, config)
       .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.style_image = response.data.url;
        this.style_details.style_image=this.style_image;
      }).catch((err) =>{
          return new Error(err.message);
        })
    }
    else{
      // alert("Please Select JPG or PNG Format Image Only");
       this.$fire({
                text:"Please Select JPG or PNG Format Image Only.",
                type: "warning",
                timer: 30000
                      })
      this.style_image = '';
      this.uploadedfile='';
    }

    },
    //new ends
     //Table Set Function
       opentable:function(){
           this.opentablemodel=!this.opentablemodel;
       },
       opentablecancel:function(){
           this.opentablemodel=!this.opentablemodel;
       },

    uploadImage(imgname,imgtype){

      const { image } = this;
      const Obj={
            style_id:this.$route.params.id,
            style_image:image

      }
      axios.post(`${CONSTANTS.API_URL}/uploaddesignimage`,Obj)
       .then(response => {
        this.style_image = response.data.url;

        this.style_details.style_image=this.style_image;
      }).catch((err) =>{
          return new Error(err.message);
        })

    },

    removeImage: function (e) {
      this.upload_image = '';
    },
  //Code for Image Ends
        //Code Ends
        //Code Ends

        //code for preview image
      previewImage(imgdata){
        document.getElementById("progress_bar").style.display = "block";
        this.temp_file=event.target.files[0];
        this.progress=0;
        this.uploadedfile = event.target.files[0];
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      data.append('file', this.uploadedfile)
      data.append('user_id',userInfo[0].user_id)
      data.append('design_id',this.$route.params.id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }

      //code for progressbar
      this.progress=0
      this.currentFile=this.uploadedfile;
      //code for progressbar
      document.getElementById("overlay").style.display = "block";
      if(this.uploadedfile.type=='image/jpeg' || this.uploadedfile.type=='image/png'){

      axios.post(`${CONSTANTS.API_URL}/previewselectedimage`,data, {header : {
         'Content-Type' : 'multipart/form-data'
       },
       onUploadProgress:function(progressEvent){
          this.progress=Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }.bind(this)
       }).then(response => {
        this.progress = Math.round((100 * response.loaded) / response.total);
        document.getElementById("overlay").style.display = "none";
        this.uploadedfile = response.data.url;
        // alert("File Uploaded Successfully");
        this.$fire({
                text:"File Uploaded Successfully.",
                type: "success",
                timer: 30000
                      })
        document.getElementById("progress_bar").style.display = "none";
      }).catch((err) =>{
          return new Error(err.message);
          this.progress=0;
          this.message="Could not upload the file!";
          this.currentFile='';
        })
    }
    },
        //code for preview image ends
     // Code for Sample Image
      AddSampleimage:function(event){
          this.sampleFile = event.target.files[0];
          // console.log("Sample File",this.sampleFile);
          this.sampleImage();
      },

      sampleImage:function(){
        // console.log("SSSSSSSSSS",this.sampleFile);
        // return false;
         // this.uploadedfile = event.target.files[0];
         let data = new FormData();
          let config = {
              header : {
               'Content-Type' : 'multipart/form-data'
             }
            }
            data.append('file', this.sampleFile)
         axios.post(`${CONSTANTS.API_URL}/uploadfiletos3`,data, {header : {
           'Content-Type' : 'multipart/form-data'
         },
         })
            .then(response => {
              // console.log("HHHHHH",response);
              // document.getElementById("overlay").style.display = "none";
                if(response.data.result == 'success') {
                  this.sampleImageurl=response.data.image_url;
                  // console.log("SFSFSFS",this.sampleImageurl);

                } else {
                 this.sampleImageurl='';
                }
              })

      },
      // End
        // Function For Action on status
    updatestylestatus: function(comment,value) {
      document.getElementById("overlay").style.display = "block";
      var status = value;
      var comment = comment;
           var userData = localStorage.getItem('userData');
           var userInfo = JSON.parse(userData)
           var user_id = userInfo[0].user_id;

       if(status!=''){
      const Obj={
        operational_status: status,
        updated_by: userInfo[0].email_id,
        user_id: userInfo[0].user_id,
        style_id: this.route_id,
        comments : comment
      }
      axios.post(`${CONSTANTS.API_URL}/updatestylestatus`,Obj)
      .then(response => {
        document.getElementById("overlay").style.display = "none";
        this.result = response.data
        if (this.result.returnmsg === 'Successful') {
          // alert("Status Updated Successfully");
          this.$fire({
                text:"Status Updated Successfully.",
                type: "success",
                timer: 30000
                      })
          this.block_status=false;
          this.addcommentModel= false;

          // this.sizeset=[];
          // this.$router.push('/style_list');
          // this.$router.push({ name: 'style_list', params: { id: "Designs_Pending_For_Approval" } })
          // this.$router.push({ path: `/design_quotes/'Designs_Pending_For_Approval'` })
          this.$router.push({ path: `/style_list/${'Designs_Pending_For_Approval'}` })
          // this.router.go(0);
          this.getdesigndetail();
        }else {
         // alert("Please Check Status");
          this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 90000
                      })

        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    }
      else{
      document.getElementById("overlay").style.display = "none";
      this.$fire({
                text:"Please Check Status",
                type: "warning",
                timer: 900000
                      })
    }
    },


       /****** Function to design details ********/
       getdesigndetail: function () {
        var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
           this.isBusy = true;

           const Obj = {
                style_id: this.$route.params.id,
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {

            this.style_details  = this.result.returnvalue[0];
            this.uploadedfile = this.style_details.style_image;
            this.selected_color_family= this.style_details.color_family;
            this.selected_pantone_no= this.style_details.pantone_no;
            this.selected_panton_type= this.style_details.panton_type;
            this.temp_color=this.style_details.color;
            this.temp_sizeset=this.style_details.no_of_sizeset;
            this.temp_story_name = this.style_details.story_name;
            this.temp_style_id = this.style_details.style_id;
            console.log("PPPPPPPPPPPPPPPPPpp",this.temp_style_id)
            var from_age=this.style_details.size_details[0].selectedfromage
            var to_age=this.style_details.size_details[0].selectedtoage
            var unit=this.style_details.size_details[0].unit;
            var temp_length=from_age.length;

            this.range_selectedtoage=parseInt(from_age[0])+temp_length-1;
            for(var i=0;i<=from_age.length;i++){
              this.range_selectedfromage=parseInt(from_age[0]);
              this.range_selected_month=parseInt(unit[0]);
            }


            this.selected_sizeset = this.style_details.no_of_sizeset;
            // this.sizeset=this.style_details.no_of_sizeset;
            this.selected_design_id = this.style_details.design_id;
             this.getDesignSampleList(this.selected_design_id)

            for(var i=1;i<=this.style_details.no_of_sizeset;i++){
              this.sizeset.push(i);
              // alert("In")
            }
            // console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT",this.sizeset)
            this.temp_style_description=this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.temp_style_image = this.style_details.style_image;

            this.fileObj_msg = this.result.returnvalue[1].file_name;

            this.selected_status_code_number = this.style_details.status_code_number;


            // console.log("########################",this.style_details.size_details[0].quantity[0])
             // alert("kkkkkk1111");



            //Added New Code
            this.temp_sizeset=this.style_details.no_of_sizeset;
             if(this.style_details.size_details[0].unit.length!=0){
                  for(let i=0;i<this.style_details.size_details[0].unit.length;i++){
                  var temp_selected_unit= this.style_details.size_details[0].unit;
              }
                  // console.log("temp_selected_unit",temp_selected_unit)
                }
              if(this.style_details.size_details[0].selectedfromage.length!=0){
                for(let i=0;i<this.style_details.size_details[0].selectedfromage.length;i++){
                var temp_selected_fromage= this.style_details.size_details[0].selectedfromage;
                // console.log("temp_selected_fromage",temp_selected_fromage)
              }
              }
              if(this.style_details.size_details[0].selectedtoage.length!=0){
                for(let i=0;i<this.style_details.size_details[0].selectedtoage.length;i++){
                var temp_selected_toage=this.style_details.size_details[0].selectedtoage;
                // console.log("temp_selected_toage",temp_selected_toage)
              }
              }

            if(this.style_details.size_details[0].quantity.length!=0){
              for(let i=0;i<this.style_details.size_details[0].quantity.length;i++){
                var temp_qty=this.style_details.size_details[0].quantity[0];
                // console.log("temp_qty",temp_qty)
              }
              }

              if(this.style_details.size_details[0].factorysize.length!=0){
                for(let i=0;i<this.style_details.size_details[0].factorysize.length;i++){
                var temp_factorysize= this.style_details.size_details[0].factorysize[0];
                // console.log("temp_factorysize",temp_factorysize)
              }
            }
                  this.unit=temp_selected_unit;
                  this.selectedfromage= temp_selected_fromage;
                  this.selectedtoage= temp_selected_toage;
                  this.quantity= temp_qty;
                  this.factorysize= temp_factorysize;
            //Added New Code Ends

             }else {
              this.style_details =[];

                this.isBusy = !this.isBusy;
             }


           })
           // .catch(e => {
           //   this.errors.push(e)
           // })


       },

         /****** Function to Get Design Sample List ********/
        getDesignSampleList: function (value) {

        this.isBusy = true;
        const Obj={
          "design_id":value
        }

        axios.post(`${CONSTANTS.API_URL}/getstylesamplelist`,Obj)
        .then(response => {
          // JSON responses are automatically parsed.
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.nav_design_list  = this.result.returnvalue;



            this.isBusy = !this.isBusy;

          }else {
           this.design_list =[];

             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


        },

          /******Function To Get PO Type List********/
      getPoTypeList: function() {
        // document.getElementById("overlay").style.display = "block";

      // this.isBusy = true;
       const Obj={
        subcat_id: this.sub_catid
       }
      axios.post(`${CONSTANTS.API_URL}/getPoTypeList`,Obj)
      .then(response => {
        // document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.po_typearr  = this.result.returnvalue;

        }else {
         this.po_typearr =[];

        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get PO Type List Ends********/


        /****** Function to design summary ********/
       getfileslisting: function () {

           this.isBusy = true;
           const Obj = {
                design_id:  this.$route.params.id,

              }

           axios.post(`${CONSTANTS.API_URL}/getdesignfilelist `,Obj)
           .then(response => {
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {

               this.files_list = this.result.returnvalue;



               this.isBusy = !this.isBusy;

             }else {
              this.files_list =[];

                this.isBusy = !this.isBusy;
             }


           })
           .catch(e => {
             this.errors.push(e)
           })


       },

       },
    watch: {
      '$route' () {
        this.route_id = this.$route.params.id
          this.getdesigndetail();
      }
    },
   };
</script>
<style>
.short-div {
  height: 55px;
}

.quote-dropdowns .dropdown--accepted {
  border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns > .card {
  background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}
.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
  align-items: center;
  justify-items: center;
  justify-content: center;
  cursor: pointer;
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}
.f-sz-l {
  font-size: 15px;
}
.flex-col {
  flex-direction: column;
}
.flex,
.flex-col {
  display: flex;
}
.f-w-semi-bold {
  font-weight: 600;
}
.f-sz-sm {
  font-size: 12px;
}
.f-w-semi-bold {
  font-weight: 600;
}

.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}

.input-grp {
  width: 100%;
  margin-bottom: 16px;
}
.input-grp {
  margin-bottom: 10px !important;
}

.input-grp label {
  margin-bottom: 6px;
  color: #333340;
}

input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"] {
  padding: 13px 12px;
  border-radius: 2px;
  border: 1px solid #bfbfbf;
}
.input-grp input,
.input-grp label,
.input-grp select {
  display: block;
  width: 100%;
}

.input-grp select:disabled {
  background-color: #ebebe4;
}
.input-grp select {
  background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
  background-position: right 8px top 6px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}

.main_body {
  width: 970px;
}
/*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
.container {
  align-content: center;
}
.search {
  border-radius: 15px 0 0 15px !important;
  background-color: white !important;
  border: 0 !important;
  color: white !important;
}
.search:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
/*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
#type_msg:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.send_btn {
  border: 1 !important;
  border-color: #20a8d8;
  background-color: #4d94ff;
  cursor: pointer;
}
.search_btn {
  border-radius: #20a8d8 !important;
  border: 0 !important;
  background-color: #20a8d8;
  cursor: pointer;
}
.contacts {
  list-style: none;
  padding: 0;
}
.contacts li {
  width: 100% !important;
  padding: 5px 10px;
  margin-bottom: 15px !important;
}

.user_img {
  height: 40px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
  margin-left: 10px;
}
.user_img_msg {
  height: 30px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
}
.text-span {
  background: blue;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.text-span2 {
  background: gray;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}

/*.mb-4, .my-4 {
    margin-bottom: 0.5rem !important;
    position: absolute;
    top: 65px;
  }*/
/* #vendor_name{
    font-size: 16px;
    color: black;
    font-style: normal
  }*/

.msg_time_send {
  position: absolute;
  right: 0;
  bottom: -15px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
}
.msg_head {
  position: relative;
}
.brandcard {
  border-radius: 0px !important;
  padding-left: 10px !important;
}

.sidebar {
  background: #17a2b8 !important;
  width: 50px !important;
}

.sidebar .sidebar-nav {
  width: 50px !important;
}
.sidebar .nav {
  width: 50px !important;
}

.main1 {
  margin-left: 50px !important;
}
#rec_msg {
  margin-left: 40%;
  position: absolute;
}

/*****CSS For Zoom Image*****/
*body {
  margin: 0;
}
#btn_navbar {
  overflow: hidden;
  text-align: center;
  /*position: fixed;*/
  top: 0;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
}
#btn_navbar a {
  float: left;
  display: block;
  color: #666;
  text-align: center;
  padding-right: 20px;
  text-decoration: none;
  font-size: 17px;
}
#btn_navbar a:hover {
  background-color: #ddd;
  color: black;
}
#btn_navbar a.active {
  background-color: #4caf50;
  color: white;
}
.main1 {
  padding: 16px;
  margin-top: 30px;
}
.main1 img {
  max-width: 100%;
  height: auto;
}
.button {
  width: 300px;
  height: 60px;
}

/*****CSS For Zoom Image Ends*****/

/*** Tabb ***/
/*.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
    width: 100%;
}
.flex {
    display: flex;
}*/

/*.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 60px;
    padding: 12px 24px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border:1px solid gray;
}*/

/*.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;

    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
}*/

html,
body {
  margin: 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color: white;
}
.header-tabs__tab {
  position: relative;
  flex: 1 1;
  height: 43px !important;
  padding: 12px 22px;
  border-bottom: 3px solid var(--fill-grey-light3);
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #63c2de;
  border-radius: 12px;
}

/*Todays CSS*/
.nav_row_tabs {
  display: flex;
  border-top: 1px solid #d7dbdd;
  border-bottom: 1px solid #d7dbdd;
}

.nav_tabs__tab--disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}

/*CSS 2710*/
.nav_tabs__tab--active:after {
  background: var(--fill-primary-blue);
}

.nav_tabs__tab-image {
  padding-right: 8px;
}
.nav_tabs__tab-block {
  display: flex;

  flex-direction: column;
  justify-content: center;
}
.nav_tabs__tab-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nav_tabs__navbar {
  margin-top: auto;
  align-items: center;
  border-top: 1px solid #d7dbdd;
}
#activeTitle {
  font-size: 14px;
}
.viewClass {
  width: 190px;
}
.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
}
.selectedcolor {
  padding: 5px;
  text-align: center;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(255, 255, 255);
  /*background-color: rgb(119 119 119);*/
  background-color: rgba(255, 255, 255, 1);
  /*background-color: rgb(119 119 119,0.9);*/
  overflow-y: hidden;
  overflow: auto;
  transition: 0.5s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 60px;
  color: #16a2d7;
}
.overlay-content {
  position: relative;
  top: 11%;
  right: 15px;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  color: #bbbaba;
}
/*.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}*/
.overlay a {
  padding: 0px;
  text-decoration: none;
  font-size: 18px;
  color: #16a2d7;
  display: block;

  transition: 0.3s;
}
.overlay a:hover,
.overlay a:focus {
  color: #0864d6;
}
.design-list__item1 {
  height: 67px;
  padding: 12px 20px;
  padding-right: 6px;
  /*border-bottom: none !important;*/
  cursor: pointer;
}
.imgsidedesign {
  width: 20%;
  height: 100%;
  border-radius: 48%;
  border: 1px solid #e4e4e4;
}
@media screen and (max-width: 1170px) {
  .side {
    display: none;
  }
}
@media screen and (min-width: 1170px) {
  .navbtn {
    display: none;
  }
}
@media screen and (min-width: 1170px) {
  .closebtn {
    display: none;
  }
}
@media screen and (min-width: 320px) {
  .overlay {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 15px;
    left: 0;
    background-color: rgb(255, 255, 255);
    /*background-color: rgb(119 119 119);*/
    background-color: rgba(255, 255, 255, 1);
    /*background-color: rgb(119 119 119,0.9);*/
    overflow-y: hidden;
    overflow: auto;
    transition: 0.5s;
  }
  .overlay .closebtn {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 30px;
    color: #16a2d7;
  }
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 9px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .f-sz-sm {
    font-size: 8px;
  }
  .design-list__subtitle1 {
    margin-left: 25px;
    border-bottom: 1px solid #e4e4e4;
  }
  .design-list__item1 {
    height: 56px;
    padding: 10px 21px;
    padding-right: 6px;
    border-bottom: 1px solid #d4d4d4;
    cursor: pointer;
  }

  .imgsidedesign {
    width: 61%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
  .design-list__title1 {
    margin-left: 25px;
  }
}
@media screen and (min-width: 411px and min-width: 414px) {
  .overlay {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 15px;
    left: 0;
    background-color: rgb(255, 255, 255);

    background-color: rgba(255, 255, 255, 1);

    overflow-y: hidden;
    overflow: auto;
    transition: 0.5s;
  }
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 11px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .design-list__subtitle1 {
    border-bottom: 1px solid #e4e4e4;
  }
  .imgsidedesign {
    width: 61%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
}
@media screen and (min-width: 1024px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .overlay .closebtn {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 45px;
    color: #16a2d7;
  }
  .design-list__title1 {
    margin-left: 55px;
    margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }
  .design-list__subtitle1 {
    border-bottom: 1px solid #e4e4e4;
  }
  .imgsidedesign {
    width: 20%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
}
@media screen and (min-width: 768px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .overlay .closebtn {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 45px;
    color: #16a2d7;
  }
  .design-list__title1 {
    margin-left: 55px;
    margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }
  .design-list__subtitle1 {
    border-bottom: 1px solid #e4e4e4;
  }
  .imgsidedesign {
    width: 30%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
}

.designtitle {
  margin-top: 0.625em;
  margin-bottom: 0.625em;
  width: 85%;
}
.dropdowndesign {
  float: right !important;
  margin-right: 0.625em !important;
}
.divdesign {
  float: left;
  border: 1px solid lightgray;
}
.imgdesign {
  padding: 0.3125em;
  height: 13.75em;
  width: 21.8125em;
}
.btndesign {
  padding: 0.3125em;
  margin-left: 30%;
}
.stylefield {
  font-size: 0.9375em !important;
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row wrap;
    justify-content: flex-start;
  }
}
@media (max-width: 320px) {
  .designtitle {
    /* margin-top:10px;
  margin-bottom:10px;*/
    width: 80%;
    font-size: 8px;
    padding: 5px;
  }
  .imgdesign {
    width: 90px;
    height: 80px;
  }
  .btndesign {
    padding: 1px;
    font-size: 9px;
    margin-top: 3px;
    margin-left: 25px;
  }
  .divdesign {
    float: left;
    border: 1px solid lightgray;
    height: 110px;
    margin-top: -50px;
    margin-bottom: 10px;
  }
  .stylefield {
    font-size: 10px !important;
  }
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 85% !important;
  }
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .selectedcolor {
    padding: 5px;
    text-align: center;
    width: 50%;
  }

  /*.colonb{
  text-align: center;
  position: absolute;
  
}
.titleb{
   position: absolute;
   width: 60%;
   
}*/
}
@media (max-width: 360px) {
  .designtitle {
    /* margin-top:10px;
  margin-bottom:10px;*/
    width: 90% !important;
    font-size: 10px !important;
    padding: 5px !important;
  }
  .imgdesign {
    width: 90px !important;
    height: 80px !important;
  }
  .btndesign {
    padding: 2px !important;
    font-size: 9px !important;
    margin-top: 3px !important;
    margin-left: 15px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 110px !important;
    margin-top: -50px !important;
    margin-bottom: 5px !important;
    margin-left: 1px !important;
  }
  .brandcard {
    padding-left: 12px !important;
  }
  .dropdowndesign {
    float: right !important;
    margin-right: 10px !important;
  }
  /*.stylefield{
  font-size: 11px !important;

    padding: 0px !important;
}*/
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 86% !important;
  }
  .stylefield {
    font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
  }
  .colonb {
    text-align: center !important;
    position: absolute !important;
    margin-left: 10px !important;
  }
  .titleb {
    position: absolute !important;
    margin-left: 50% !important;
  }
}
@media (max-width: 280px) {
  .designtitle {
    /* margin-top:5px;
  margin-bottom:5px;*/
    width: 70% !important;
    font-size: 9px !important;
    /*padding: 10px !important;*/
  }
  .imgdesign {
    width: 80px !important;
    height: 60px !important;
  }
  .btndesign {
    padding: 3px !important;
    font-size: 9px !important;
    margin-top: 5px !important;
    margin-left: 9px !important;
  }
  /*.divdesign{
  float: left;
  border: 1px solid lightgray;
  height: 95px !important;
}*/
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 95px !important;
    margin-top: -50px !important;
    margin-bottom: 5px !important;
  }
  /*.brand-card {
    padding-left: 10px !important;
}*/
  .dropdowndesign {
    /*float: right;*/
    margin-right: 10px !important;
    /*margin-bottom:10px;*/
  }
  .stylefield {
    font-size: 10px !important;
    padding: 0px !important;
  }
  .coldesign {
    flex: 0 0 104% !important;
    max-width: 105% !important;
  }
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .selectedcolor {
    padding: 1px;
    text-align: center;
    width: 50%;
  }
}
@media (max-width: 450px) and (min-width: 350px) {
  .designtitle {
    /*margin-top:5px;
  margin-bottom:5px;*/
    width: 80% !important;
    font-size: 10px !important;
    padding: 10px !important;
  }
  .imgdesign {
    width: 120px !important;
    height: 90px !important;
  }
  .btndesign {
    padding: 4px !important;
    font-size: 10px !important;
    margin-top: 5px !important;
    margin-left: 25px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 130px !important;
    margin-top: -50px !important;
    margin-bottom: 10px !important;
  }
  .brandcard {
    padding-left: 15px !important;
  }
  .dropdowndesign {
    float: right !important;
    margin-right: -34px !important;
    margin-bottom: 10px !important;
  }
  .stylefield {
    font-size: 10px !important;
    padding: 0px !important;
    margin-left: -16px !important;
  }
  /*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 85% !important;
  }
  /*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
  .colonb {
    text-align: center !important;
    position: absolute !important;
    margin-left: 10px !important;
  }
  .titleb {
    position: absolute !important;
    margin-left: 50% !important;
  }
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .selectedcolor {
    padding: 5px;
    text-align: center;
    width: 50%;
  }
}
@media (max-width: 540px) and (min-width: 450px) {
  .designtitle {
    /*margin-top:5px;
  margin-bottom:5px;*/
    width: 80% !important;
    font-size: 13px !important;
    padding: 10px !important;
  }
  .imgdesign {
    width: 150px !important;
    height: 120px !important;
  }
  .btndesign {
    padding: 4px !important;
    font-size: 10px !important;
    margin-top: 5px !important;
    margin-left: 35px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 160px !important;
    margin-top: -50px !important;
    margin-bottom: 10px !important;
  }
  /*.brandcard {
    padding-left: 15px !important;
}*/
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .dropdowndesign {
    float: right !important;
    margin-right: -10px !important;
    margin-bottom: 5px !important;
  }
  .stylefield {
    font-size: 13px !important;
    padding: 0px !important;
    margin-left: -16px !important;
  }
  /*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 85% !important;
  }
  /*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
  .colonb {
    text-align: center !important;
    position: absolute !important;
    margin-left: 10px !important;
  }
  .titleb {
    position: absolute !important;
    margin-left: 50% !important;
  }

  .selectedcolor {
    padding: 5px;
    text-align: center;
    width: 50%;
  }
}
/*@media (max-width: 360px)
{
  
}*/
@media (max-width: 768px) and (min-width: 550px) {
  .designtitle {
    /*   margin-top:5px !important;
  margin-bottom:5px !important;*/
    width: 80% !important;
    font-size: 17px !important;
    padding: 10px !important;
  }
  .imgdesign {
    width: 220px !important;
    height: 150px !important;
  }
  .btndesign {
    padding: 4px !important;
    font-size: 10px !important;
    margin-top: 5px !important;
    margin-left: 70px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 190px !important;
    margin-top: -40px !important;
    margin-bottom: 10px !important;
    margin-left: 40px !important;
  }
  /*.brand-card {
    padding-left: 15px !important;
}*/
  .dropdowndesign {
    float: right;
    margin-right: 5px !important;
    /*margin-bottom:10px !important;*/
  }
  .stylefield {
    font-size: 15px !important;
    padding: 0px !important;
    margin-left: 30px !important;
  }
  .coldesign {
    flex: 0 0 85% !important;
    max-width: 100% !important;
  }
}
@media (max-width: 700px) {
  .designtable {
    display: none;
  }
}

@media (min-width: 700px) {
  .tablebtn {
    display: none;
  }
}
@media (max-width: 375px) and (min-width: 350px) {
  .tdhead {
    font-size: 8px;
  }
  .tdsize {
    font-size: 8px;
  }
  .tdunit {
    font-size: 12px;
    width: 35px;
    padding: 2px;
  }
  .tdageform {
    padding: 2px;
    font-size: 13px;
    width: 40px;
  }
  .tdageto {
    padding: 2px;
    width: 40px;
    font-size: 13px;
  }
  .tdfactory {
    padding: 7px !important;
    font-size: 12px !important;
    width: 35px !important;
    height: 23px !important;
  }
  .tdquantity {
    padding: 7px !important;
    font-size: 12px !important;
    width: 36px !important;
    height: 23px !important;
  }
  .tabset {
    margin-left: -13px;
  }
}
@media (max-width: 320px) {
  .tabset {
    margin-left: -9px;
    overflow: auto;
  }
}
@media (max-width: 300px) {
  .tabset {
    margin-left: -9px;
    overflow: auto;
  }
}
@media (max-width: 450px) {
  .tdhead {
    font-size: 10px !important;
  }
  .tdsize {
    font-size: 10px !important;
  }
  .tdunit {
    padding: 3px !important;
    font-size: 15px !important;
    width: 40px !important;
    height: 27px !important;
  }
  .tdageform {
    padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
    height: 27px !important;
  }
  .tdageto {
    padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
    height: 27px !important;
  }
  .tdfactory {
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
  .tdquantity {
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
}
@media (max-width: 540px) and (min-width: 500px) {
  .tdunit {
    padding: 5px !important;
    font-size: 15px !important;
    width: 45px !important;
    height: 32px !important;
  }
  .tdageform {
    padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  .tdageto {
    padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  /*.tdfactory{
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
 .tdquantity{
     padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
 }*/
}
@media (max-width: 1040px) {
  .detailside {
    display: none;
  }
}
</style>
